import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import Breadcrumbs from '../../../common-elements/breadcrumbs/Breadcrumbs'
import CreateOrganization from './CreateOrganization'
import ButtonSection from './ButtonSection'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const CreateContainer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {t}=useTranslation()
  
  const handleClose=()=>{
    navigate('/masterdata/organization')
  }

  return (
    <>
      <Breadcrumbs
        mainTitle= {id ? t("EditOrganization") : t("AddOrganization")}
        parents={[
          { label: "Master Data" },
          {
            label: t("Organizations"),
            link: `${process.env.PUBLIC_URL}/masterdata/organization`,
          },
        ]}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateOrganization />
                <ButtonSection onClose={handleClose} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default CreateContainer